export default __webpack_public_path__ + "static/media/cannabis_icon.7da089c0.svg";